"use strict";

/**
 * @classdesc
 * Zeigt an, dass eine Aktion auf ein Gebiet außerhalb des max. Extents (Gebietsfilter) angewendet werden soll.
 *
 * @class
 * @extends gc.gis.error.GCError
 * @memberof gc.gis.error
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {string} message Beschreibung des Fehlers
 * @param {Error} [opt_cause] Optionale Ursache dieses Fehlers
 */
gc.gis.error.GCOutOfMaxExtentError = function(message, opt_cause)
{
	gc.gis.error.GCError.call(this, message, opt_cause);

	this.name    = 'gc.gis.error.GCOutOfMaxExtentError';
	this.message = message;
};
gc.gis.error.GCOutOfMaxExtentError.prototype = Object.create(gc.gis.error.GCError.prototype);

